<template>
  <DialogContent class="max-w-[450px]">
    <div class="font-semibold mb-[30px]">
      <span class="text-red-500"> Additional {{ discount }}% savings </span>
      by paying annually!
    </div>

    <div class="flex flex-col gap-y-2.5 mb-4">
      <PlanBillingOption
        v-for="plan in props.plans"
        v-model="selectedPlan"
        :key="plan.id"
        :plan="plan"
      />
    </div>

    <UiButton class="w-full mb-4" primary large @click="handleClick">
      Continue
    </UiButton>

    <div class="text-[12px] leading-[20px] text-gray-500 text-center">
      Billed {{ billingCycle }}. Cancel anytime. Subscription is auto-renewable.
      By subscribing you agree to the Dacr
      <span class="inline-flex mr-1">
        <a
          href="/legal/terms"
          target="_blank"
          class="font-medium underline"
          @click="handleTermsClick"
        >
          Terms
        </a>
        ,
      </span>
      <span class="inline-flex">
        <a
          href="/legal/privacy"
          class="font-medium underline"
          @click="handlePrivacyClick"
        >
          Privacy Policy
        </a>
        ,
      </span>
      and
      <a
        href="/legal/pricing"
        class="font-medium underline"
        @click="handlePricingClick"
      >
        Payment Terms
      </a>
    </div>
  </DialogContent>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import PlanBillingOption from '@/features/billing/components/PlanBillingOption.vue'
import { UiButton } from '@dacr/ui'
import { PlanPriceType, type Plan } from '@/shared/graphql/legacy/generated'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'

const { close, triggerEvent } = useDialog()

const props = defineProps<{
  plans: Plan[]
}>()

const webviewStore = useWebviewStore()

const selectedPlan = ref<Plan>(props.plans[1])

const discount = computed(() => (props.plans[0].items.length > 1 ? 25 : 40))

const billingCycle = computed(() => {
  const cycle = selectedPlan.value.items[0].prices.find(
    (price) => price.type === PlanPriceType.Subscription
  )?.details?.billingCycleType

  return cycle === 'month' ? 'monthly' : 'annually'
})

const handleTermsClick = (e: MouseEvent) => {
  if (webviewStore.isActive) {
    e.preventDefault()
    webviewStore.postMessage({
      type: NativeActionsEnum.LinkOpen,
      data: `${import.meta.env.VITE_URL}/legal/terms`,
    })
  }
}

const handlePrivacyClick = (e: MouseEvent) => {
  if (webviewStore.isActive) {
    e.preventDefault()
    webviewStore.postMessage({
      type: NativeActionsEnum.LinkOpen,
      data: `${import.meta.env.VITE_URL}/legal/privacy`,
    })
  }
}

const handlePricingClick = (e: MouseEvent) => {
  if (webviewStore.isActive) {
    e.preventDefault()
    webviewStore.postMessage({
      type: NativeActionsEnum.LinkOpen,
      data: `${import.meta.env.VITE_URL}/legal/pricing`,
    })
  }
}

const handleClick = async () => {
  triggerEvent('success', selectedPlan.value)
}
</script>
